<template>
  <div class="changeParkconfirm" v-if="params.dialogVisible ">
    <div class="m">
      <div class="box">
        <div class="kuang"></div>
        <div class="arrow"></div>
        <div class="text">当前园区不在活动范围内，可尝试切换园区</div>
        <div class="btn" @click="params.dialogVisible=false">知道了</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props:{
        params:{
            type:Object
        }
    },
    // params:{ 传参示例
    //     dialogVisible:true
    // }
};
</script>

<style lang="scss" scoped>
.changeParkconfirm {
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  width: 100%;
  height: 100%;
  .m {
    position: relative;
  }
  .box {
    position: absolute;
    left: 53px;
    top: 10px;
    .kuang {
      width: 145px;
      height: 43px;
      border: 2px dashed rgba(255, 255, 255, 1);
      border-radius: 2px;
    }
    .arrow {
      height: 153px;
      width: 86px;
      background: url("~@/assets/img/common/arrow.png") no-repeat;
      background-size: cover;
      margin: 30px 0 0 100px;
    }
    .text {
      height: 40px;
      margin-left: 212px;
      font-size:18px;
    }
    .btn {
      width: 120px;
      height: 38px;
      line-height: 38px;
      text-align: center;
      border: 1px solid rgba(255, 255, 255, 1);
      border-radius: 19px;
      cursor: pointer;
      margin-left: 212px;
    }
  }
}
</style>